import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../styles";

import styled from "@emotion/styled"; 

const BoldText = styled.div`
  font-family: "two-cent-Bold";
  font-size: 26px;
`;
const BuyButton = styled.button`
  margin-top: 10px;
  background-color: #ffff;
  font-family: "twocent-bold-italic";
  color: #36403f;
  width: 120px;
  border: none;
  height: 40px;
  font-size: 18px;
  cursor: pointer;
`;
const ChartButton = styled.button`
  cursor: pointer;
  background-color: #ffff;
  font-family: "twocent-bold-italic";
  color: #36403f;
  width: 120px;
  height: 40px;
  border: none;
  margin-left: 10px;

  font-size: 18px;
`;

const DogDoller = styled.div`
  position: absolute;
  right: 280px;
  top: 120px;
  @media screen and (max-height: 700px) {
    top: 130px;
    right: 100px;
    width: 454px;
  }
  @media screen and (max-width: 1300px) {
    right: 100px;
    width: 354px;
    top: 220px;
  }
  @media screen and (max-width: 1050px) {
    right: 100px;
    width: 354px;
    top: 220px;
  }
  @media screen and (max-width: 950px) {
    display: none;
  }
`;
const DollarImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 475px;
`;
const index = () => {
  return (
    <div style={{ backgroundColor: "#4F8443" }}>
      <SectionWrapper
        mh410="115vh"
        bgColor="#36403F"
        id="dollarinu"
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // data-aos-delay="500"
        // data-aos-offset="0"
      >
        <Container maxWidth="xl">
          <SectionHeading>Doller Inu</SectionHeading>

          <DogDoller>
            <DollarImage src="/images/dollardog.png" />
          </DogDoller>

          <Grid container>
            <Grid xs={12} md={6}>
              <P maxWidth="600px" mt="0px">
                What better name for the token other than ‘Dollar Inu’, right?
                (for those of you who don’t remember, ‘Dollar’ was the name of
                Richie Rich’s dog!).
                <br />
                <br />
                Dollar Inu will be launched on Ethereum. Holders of Dollar Inu
                will get eligible for airdrop of RRT (Richie Rich Token) which
                will be the native token of RRC! The airdrop will take place 30
                days right after the ‘Sacrifice Phase’ has started.
              </P>
              <BoldText>Dollar Inu Contract Address:</BoldText>
              <P>Eth: 0x4dasd731324dE180c4C1eD87ca74sa34dDEbCdf4sq</P>

              <BuyButton>Buy Now</BuyButton>
              <ChartButton>Chart</ChartButton>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
